import { gql } from '@apollo/client'

export const GET_THEME_PARAMS = gql`
  query School($url: String!) {
    school(url: $url) {
      id
      name
      organizationId
      logo
      domains
      email
      featuresAvailable
      publishedHomepage
      subdomain
    }
  }
`
